/*
 * @fileOverView Search Employer component definition
 */

import Vue from 'vue';
import Search from 'components/modules/utility/search/search.mixin';
/**
 * [Search Employer Vue]
 * @type {class}
 */
Vue.component('search-employer-vue', {
  mixins: [Search],

  methods: {
    /**
     * Handles keypresses on the search toggle.
     *
     * @method handleToggleKeydown
     * @param {Number} first index - The index of the first item in the array.
     * @public
     */
    handleToggleKeydown(index) {
      // Do Nothing.
    },

    /**
     * Given a keycode, focuses the next relevant item.
     *
     * @method focusItem
     * @param {Number} currentIndex - The index of the currently selected item.
     * @public
     */
    focusItem(index) {
      // Do Nothing.
    },

    /**
     * Handles submission of search form on selection of a term.
     *
     * @method handleSubmit
     * @public
     */
    handleSubmit() {
      this.$store.dispatch('employers/search', this.search);
    },

    /**
     * Handles selection of an item from a click or keypress.
     *
     * @method handleItemSelected
     * @param {Object} event - Javascript event object
     * @public
     */
    handleItemSelected(e) {
      //Do nothing, these are links
    }
  }
});
